import { CRONOFY_REQUEST_EXTENDED_PERMISSIONS } from '@/gql/cronofy';
import {
  CronofyRequestExtendedPermissionsPayload,
  CronofyRequestExtendedPermissionsResponse,
} from '@/gql/cronofy/types';
import { fetchData } from '@/services/graphql';
import { useMutation } from '@tanstack/react-query';

const useCronofyRequestExtendedPermissions = () => {
  return useMutation({
    mutationFn: (payload: CronofyRequestExtendedPermissionsPayload) =>
      fetchData<CronofyRequestExtendedPermissionsResponse>(CRONOFY_REQUEST_EXTENDED_PERMISSIONS, payload),
  });
};

export default useCronofyRequestExtendedPermissions;
